import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCourseDisplayName_course$key } from "./__generated__/useCourseDisplayName_course.graphql";

export const useCourseDisplayName = (
  courseRef: useCourseDisplayName_course$key | null
) => {
  const course = useFragment(CourseDisplayNameFragmentString, courseRef);

  const facilityHasMultipleCourses = (course?.facility.courses?.count || 0) > 1;

  return facilityHasMultipleCourses
    ? `${course?.facility.name} - ${course?.name}`
    : course?.facility?.name;
};

const CourseDisplayNameFragmentString = graphql`
  fragment useCourseDisplayName_course on Course {
    name
    facility {
      name
      courses(archived: false) {
        count
      }
    }
  }
`;
